import styled from "styled-components"

import Flex from "../../Flex"

export const Container = styled(Flex)`
  height: 65px;
  border: ${({theme}) => `1px solid ${theme.colors.greys.grey20}`};
  padding: ${({theme}) => `${theme.spacing.oneAndHalf} ${theme.spacing.oneAndHalf}`};
  background-color: ${({theme}) => theme.colors.greys.white};
`
